// extracted by mini-css-extract-plugin
export default {"delayedContent":"exx8C8VXxT_pdp","delayed-content":"KPimB56OkW_pdp"};